import { api } from '@services/api/api';
import { Result } from '@utils/index';
import { AxiosResponse } from 'axios';
import {
  toUniqueFieldsErr,
  UpdateContentError,
} from '../customField/updateCustomFieldContent/updateCustomFieldContent';
import { InventoryQueryParams } from './getEquipments/makeParamsObject';

export interface IPatchEquipmentArrayLambdaVariables {
  purchasedPrice?: number | null;
  userId?: string | null;
  licenseStartDate?: Date | null;
  licenseEndDate?: Date | null;
  purchasedDate?: Date | null;
  extendedWarrantyPurchased?: boolean | null;
  installDate?: Date | null;
  studioId?: string;
  // id?: string;
  productId?: string | null;
  // serial: string;

  purchasedFrom?: string | null;
  installedSoftwareVersion?: string | null;
  installedFirmwareVersion?: string | null;
  customFields?: {
    id: string;
    content: string | null;
  }[];
  tags?: {
    tagId: string;
    action: 'ADD' | 'REMOVE';
  }[];
  equipmentStatusId?: string | null;
  /* Undefined when sending select all. Some kind of filter param must be defined otherwise. */
  query?: Partial<InventoryQueryParams>;
  deselectedItems: string[];
}
type IResponse = AxiosResponse;
export async function patchEquipmentArrayLambda(
  params: IPatchEquipmentArrayLambdaVariables,
) {
  const axiosResponse = api.post('/invocations/massEditAll', params);
  const result = await Result.asyncCatch<UpdateContentError, IResponse>(
    axiosResponse,
  );

  const result_map = Result.mapErr(result, toUniqueFieldsErr);
  if (result_map.is_ok) {
    const { data } = result_map.data;
    return data;
  }
  throw result_map.error;
}
